import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { Select, Button } from "@mantine/core";
import { sensorType, deskType } from "../interfaces/groups";
import { notifications } from "@mantine/notifications";
import SensorLogs from "./SensorLogs";
import { CiViewList } from "react-icons/ci";
import {
  resetGetDesksStatus,
  resetGetFloorStatus,
} from "../redux/slices/groups.slice";
import {
  useUpdateDeskInfoMutation,
  useGetDesksQuery,
} from "../redux/slices/api.slice";
import { useAppSelector } from "../redux/hooks";

import { useParams } from "react-router-dom";
import { useAppDispatch } from "../redux/hooks";
import { SearchableSelect } from "./SearchableSelect";

type propType = {
  setOpenControlBar: (input) => void;
  availableSensors: sensorType[];
  deskInfo?: deskType;
  setDeskInfo: any;
};

const ControlBar = ({
  setOpenControlBar,
  availableSensors,
  deskInfo,
  setDeskInfo,
}: propType) => {
  const dispatch = useAppDispatch();
  const { id } = useParams();
 
  const { desks } = useAppSelector((state) => state.groups);
  const [selectedSensor, setSelectedSensor] = useState("");
  const [deskName, setDeskName] = useState("");
  const [deskStatus, setDeskStatus] = useState("");
  const [openSensorLogs, setOpenSensorLogs] = useState(false);
  const s = availableSensors.map((s) => {
    return s.id;
  });
 
  const Status = [
    { label: "Blocked", value: "Blocked" },
    { label: "Under Maintenance", value: "Under Maintenance" },
    { label: "Occupied", value: "Occupied", disabled: deskInfo.status === "Occupied" },
    { label: "Unoccupied", value: "Unoccupied", disabled: deskInfo.status === "Unoccupied" },
    { label: "No status", value: "No status" },
  ];
  const sensors = Array.from(
    new Set(["No sensor", ...s, deskInfo.sensorID])
  ).filter(Boolean);

  const [updateDeskInfo, { isLoading }] = useUpdateDeskInfoMutation();

  useEffect(() => {
    const desk = desks?.[deskInfo.floorID].find((d) => d.id === deskInfo.id);

    if (desk) {
      setDeskInfo(desk);
    }
  }, [desks]);
  
  useEffect(() => {
    setSelectedSensor(deskInfo.sensorID);
    setDeskName(deskInfo.alias);
    setDeskStatus(deskInfo.status);
  }, [deskInfo]);

  const handleCancel = () => {
    setOpenControlBar(false);
  };

  const handleEditName = async (e) => {
    e.preventDefault();
    try {
      const res = await updateDeskInfo({
        deskID: deskInfo.id,
        updatedData: {
          alias: deskName,
          floorID: deskInfo.floorID,
        },
        action: "update",
      });
      //@ts-ignore
      if (res.data) {
        notifications.show({
          title: "Success",
          message: "Name edited successfully",
          color: "green",
        });

        dispatch(resetGetDesksStatus({ floorID: deskInfo.floorID }));
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (error) {
      console.error("Mutation error:", error);
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }
  };

  const handleAssignSensor = async (e) => {
    e.preventDefault();

    try {
      const res = await updateDeskInfo({
        deskID: deskInfo.id,
        updatedData: {
          floorID: deskInfo.floorID,
          sensorID:
            selectedSensor === "No sensor"
              ? ""
              : !selectedSensor
              ? deskInfo.sensorID === "No sensor"
                ? ""
                : deskInfo.sensorID
              : selectedSensor,
        },
        action:
          !selectedSensor || selectedSensor === "No sensor"
            ? "unassign"
            : "assign",
      });
      //@ts-ignore
      if (res.data) {
        dispatch(resetGetDesksStatus({ floorID: deskInfo.floorID }));
        notifications.show({
          title: "Success",
          message: "Sensor edited successfully",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (error) {
      console.error("Mutation error:", error);
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }
  };

  const handleEditStatus = async (e) => {
    e.preventDefault();
    try {
      const res = await updateDeskInfo({
        deskID: deskInfo.id,

        updatedData: {
          floorID: deskInfo.floorID,
          status: deskStatus === "No status" ? "" : deskStatus,
          sensorId: deskInfo.sensorID,
          alias: deskInfo.alias
        },
        action: "status",
      });
      //@ts-ignore
      if (res.data) {
        dispatch(resetGetDesksStatus({ floorID: deskInfo.floorID }));

        notifications.show({
          title: "Success",
          message: "Status edited successfully",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (error) {
      console.error("Mutation error:", error);
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }
  };

  return (
    <div className="w-full  p-5 sticky top-10 right-0 ">
      <div className="flex items-center justify-between text-grayText text-2xl  mb-10 lg:my-10">
        <h3 className="font-bold text-grayText">Editing Desk View</h3>
        <IoMdClose
          className="font-bold hover:cursor-pointer "
          style={{ color: "#404F65 !important" }}
          onClick={() => setOpenControlBar(false)}
        />
      </div>

      <div className="lg:justify-between gap-4 lg:gap-0  items-center flex mb-8 ">
        <h4 className="text-sm  ">Desk ID</h4>
        <p className="bg-breadCrumbGray text-white p-1 rounded-md text-sm">
          {deskInfo?.id}
        </p>
      </div>
      {/* <div className="flex flex-row lg:flex-col items-center   gap-6 lg:items-start w-full "> */}
      <div className="grid grid-cols-1  min-[400px]:grid-cols-2 sm:grid-cols-3 lg:grid-cols-1 gap-6  w-full ">
        <form onSubmit={handleEditName} className="flex gap-2 flex-col w-full">
          <div className="flex flex-col">
            <label className="text-sm font-bold pb-[10px] pt-1">
              Desk Name
            </label>
            <input
              type="text"
              className="border-lightGray2 rounded-xl  py-1 px-2 border-solid border "
              value={deskName}
              onChange={(e) => setDeskName(e.target.value)}
            />
          </div>
          <Button
            type="submit"
            color={"#FB6514"}
            disabled={deskInfo.alias === deskName}
            loading={isLoading && deskInfo.alias !== deskName}
          >
            Save
          </Button>
        </form>

        <form
          onSubmit={handleAssignSensor}
          className="flex gap-2 flex-col  w-full"
        >
          <div className="flex flex-col">
            <h4 className="pb-3 text-sm ">Connected Sensor</h4>
            <SearchableSelect
              data={sensors}
              value={selectedSensor}
              setValue={setSelectedSensor}
            />
          </div>

          <Button
            type="submit"
            disabled={
              deskInfo.sensorID === selectedSensor ||
              (selectedSensor === "No sensor" && !deskInfo.sensorID)
            }
            color={"#FB6514"}
            loading={isLoading && deskInfo.sensorID !== selectedSensor}
          >
            Save
          </Button>
        </form>

        <form
          onSubmit={handleEditStatus}
          className="flex gap-2 flex-col  w-full"
        >
          <Select
            label={<h4 className="pb-2">Desk status</h4>}
            data={Status}
            value={deskStatus}
            onChange={(value) => setDeskStatus(value)}
          />
          <Button
            type="submit"
            color={"#FB6514"}
            loading={isLoading && deskInfo.status !== deskStatus}
            disabled={deskInfo.status === deskStatus}
          >
            Save
          </Button>
        </form>

        <Button
          variant="outline"
          className="!w-full mt-10"
          size="md"
          radius={"md"}
          onClick={() => {
            setOpenSensorLogs(true);
          }}
        >
          Sensor Logs
        </Button>
        {openSensorLogs && (
          <SensorLogs
            open={openSensorLogs}
            handleClose={() => {
              setOpenSensorLogs(false);
            }}
            sensorID={deskInfo.sensorID}
          />
        )}
      </div>
    </div>
  );
};

export default ControlBar;
